import React, {FunctionComponent} from 'react';

export const ButtonSpinner: FunctionComponent = () => (
  <div className="flex justify-center items-center ml-8">
    <div className="spinner-border animate-spin inline-block w-5 h-5 border-2 rounded-full float-right" style={{borderRightColor: "transparent"}} role="status">
    </div>
  </div>
)